import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { addManyToFavourites } from '../Actions/Favourites.action';
import constants from '../constants';
import {
    setQuery,
    search,
    remove,
    clearArticleList,
    setQuantity
} from '../Actions/DropZone.action';
import {
    clear as clearCart,
    addMany as addManyToCart
} from '../Actions/Cart.action';

class DropZoneContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
    }

    componentDidMount() {
        if (!this.props || !this.props.dropZone) {
            return;
        }
    }
    componentDidUpdate() {
        const { dropZone } = this.props;
        if (!dropZone.errors) {
            return;
        }
    }

    removeArticle(systemId) {
        this.props.remove(systemId);
    }

    searchArticle(mobile) {
        this.props.search(mobile);
        this.clearDropZone();
    }

    keyDown(event, mobile) {
        switch (event.keyCode) {
            case 13:
                this.props.search(mobile);
                this.clearDropZone();
                event.preventDefault();
                break;
            default:
                break;
        }
    }

    clearDropZone() {
        this.setState({ dropZone: { ...this.props.dropZone, query: '' } });
    }

    addArticlesToCart(event) {
        const articles = Object.keys(this.props.dropZone.articles).map((key) => this.props.dropZone.articles[key]);
        const addToCartObjectArray = [];
        for (var i = 0; i < articles.length; i++) {
            if (articles[i].buyable > 3 && articles[i].quantity !== '-') {
                addToCartObjectArray.push({ articleNumber: articles[i].id, quantity: articles[i].quantity });
            }
        }
        if (addToCartObjectArray.length > 0) {
            this.props.addManyToCart(event.target, addToCartObjectArray);
            setTimeout(() => {
                this.setState({ dropZone: { query: '', showInfo: false } });
                this.props.clearArticleList();
            }, 700);
        }
    }

    addArticlesToFavourites(event) {
        const articles = Object.keys(this.props.dropZone.articles).map((key) => this.props.dropZone.articles[key]);
        const addToFavouritesObjectArray = [];
        for (var i = 0; i < articles.length; i++) {
            if (articles[i].isFavouritable) {
                addToFavouritesObjectArray.push({ articleNumber: articles[i].id });
            }
        }
        if (addToFavouritesObjectArray.length > 0) {
            this.props.addManyToFavourites(addToFavouritesObjectArray);
            this.setState({ dropZone: { query: '', showInfo: false } });
            this.props.clearArticleList();
        }
    }

    resetCart(event) {
        if (confirm(translate('common.dropzone.cartwarning'))) {
            this.props.clearCart(event.target);
        }
    }

    querySet(query) {
        this.setState({ dropZone: { ...this.props.dropZone, query: query, showInfo: true } });
        this.props.setQuery(query);
    }

    toggle() {
        this.setState({ dropZone: { ...this.props.dropZone, showInfo: !this.state.dropZone.showInfo } });
    }
    
    setDropzoneFocus(event) {
         if (event.keyCode === 13) {
            if (this.props.mobile){
                document.getElementsByClassName('dropzone-input-mobile')[0].focus();
            }
            else{
                document.getElementsByClassName('dropzone-input-desktop')[0].focus();
            }
            
             event.preventDefault();
         }
    }
    

    render() {
        const articles = Object.keys(this.props.dropZone.articles).map((key) => this.props.dropZone.articles[key]);
         var showClearCartButton = false;
         var cartQuantity = document.getElementsByClassName('cart__quantity');
         if (cartQuantity.length> 0){
             showClearCartButton = cartQuantity[0].innerHTML !== '0';
         }
        if (this.props.mobile) {
            return (
                <Fragment>
                    <div className="navbar__link dropzone-wrapper" onClick={() => this.toggle()}>{translate('common.dropzone.title')}</div>
                    <div className={`dropzone ${!this.state.dropZone.showInfo ? 'dropzone--hidden' : ''}`}>
                        <div className="close-button" onClick={() => this.toggle()}></div>
                        <textarea className="dropzone__input dropzone-input-mobile" placeholder={translate('common.dropzone.search')} autoComplete="off" value={this.state.dropZone.query}
                            onKeyDown={event => this.keyDown(event, true)}
                            onBlur={event => this.searchArticle(true)}
                            onChange={event => this.querySet(event.target.value)}>
                        </textarea>

                        <div className="articles-wrapper">
                            {articles && articles.map(article => (
                                <div key={article.id}>
                                    <label>{article.name}</label>
                                    <input className={"art-no " + article.searchResultCssClass} type="text" value={article.id} readOnly />
                                    <input className="dropzone-quantity dropzone-quantity-mobile" type="text" value={article.name === '-' ? '-' : article.quantity} onChange={event => this.props.setQuantity(article.systemId, event.target.value)} onKeyDown={event => this.setDropzoneFocus(event)} />
                                    {constants.showStock && <div className="stockStatus">
                                        <span className={"product__instock product__instock--" + article.stockStatusCssClass}></span>
                                    </div>}
                                    <div className="removeButton">
                                        <button onClick={() => this.removeArticle(article.systemId)}><i className="fa fa-trash" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="dropzone__buttons">
                            <button className="button dropzone__button dropzone__cleararticles-button" type="button" onClick={event => this.props.clearArticleList(event)}>
                                <span className="dropzone__cart-cleararticles-title">{translate('common.dropzone.cleararticles')}</span>
                            </button>
                            <button className="button dropzone__button dropzone__favourites-button" type="button" onClick={event => this.addArticlesToFavourites(event)}>
                                <span className="dropzone__cart-favourites-title">{translate('common.dropzone.favourites')}</span>
                            </button>
                            <button className="button dropzone__button dropzone__cart-button" type="button" onClick={event => this.addArticlesToCart(event)}>
                                <span className="dropzone__cart-button-title">{translate('common.dropzone.addtocart')}</span>
                            </button>
                            {showClearCartButton &&
                                <button className="button dropzone__button dropzone__clearcart-button" type="button" onClick={event => this.resetCart(event)}>
                                    <span className="dropzone__clearcart-button-title">{translate('common.dropzone.clearcart')}</span>
                                </button>
                            }
                        </div>

                    </div>
                </Fragment>
            )
        }
        else {
            return (
                <Fragment>
                    <span className="top-link__title" onClick={() => this.toggle()}>{translate('common.dropzone.title')}</span>
                    <span className={`arrow-down ${this.state.dropZone.showInfo ? 'arrow-up' : ''}`} onClick={() => this.toggle()}></span>
                    <div className={`dropzone ${!this.state.dropZone.showInfo ? 'dropzone--hidden' : ''}`}>
                        <div className="close-button" onClick={() => this.toggle()}></div>
                        <textarea className="dropzone__input dropzone-input-desktop" placeholder={translate('common.dropzone.search')} autoComplete="off" value={this.state.dropZone.query}
                            onKeyDown={event => this.keyDown(event, false)}
                            onBlur={event => this.searchArticle(false)}
                            onChange={event => this.querySet(event.target.value)}>
                        </textarea>

                        <div className="articles-wrapper">
                            {articles && articles.map(article => (
                                <div key={article.id}>
                                    <label>{article.name}</label>
                                    <input className={"art-no " + article.searchResultCssClass} type="text" value={article.id} readOnly />
                                    <input className="dropzone-quantity dropzone-quantity-desktop" type="text" value={article.name === '-' ? '-' : article.quantity} onChange={event => this.props.setQuantity(article.systemId, parseInt(event.target.value))} onKeyDown={event => this.setDropzoneFocus(event)} />
                                    {constants.showStock && <div className="stockStatus">
                                        <span className={"product__instock product__instock--" + article.stockStatusCssClass}></span>
                                    </div>}
                                    <div className="removeButton">
                                        <button onClick={() => this.removeArticle(article.systemId)}><i className="fa fa-trash" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="dropzone__buttons">
                            <button className="button dropzone__button dropzone__cleararticles-button" type="button" onClick={event => this.props.clearArticleList(event)}>
                                <span className="dropzone__cart-cleararticles-title">{translate('common.dropzone.cleararticles')}</span>
                            </button>
                            <button className="button dropzone__button dropzone__favourites-button" type="button" onClick={event => this.addArticlesToFavourites(event)}>
                                <span className="dropzone__cart-favourites-title">{translate('common.dropzone.favourites')}</span>
                            </button>
                            <button className="button dropzone__button dropzone__cart-button" type="button" onClick={event => this.addArticlesToCart(event)}>
                                <span className="dropzone__cart-button-title">{translate('common.dropzone.addtocart')}</span>
                            </button>
                            {showClearCartButton &&
                                <button className="button dropzone__button dropzone__clearcart-button" type="button" onClick={event => this.resetCart(event)}>
                                    <span className="dropzone__clearcart-button-title">{translate('common.dropzone.clearcart')}</span>
                                </button>
                            }
                        </div>

                    </div>
                </Fragment>
            )
        }
    }
}


    const mapStateToProps = state => {
        const { dropZone } = state;
        return {
            dropZone
        }
    }

    const mapDispatchToProps = dispatch => {
        return {
            setQuery: (text) => dispatch(setQuery(text)),
            setQuantity: (systemId, q) => dispatch(setQuantity(systemId, q)),
            search: (mobile) => dispatch(search(mobile)),
            clearArticleList: () => dispatch(clearArticleList()),
            remove: (systemId) => dispatch(remove(systemId)),
            onKeyDown: (event, opt) => dispatch(handleKeyDown(event, opt)),
            addManyToCart: (buttonDomNode, articles) => {
                const nodeIdToShowNotification = buttonDomNode.id = Date.now();
                dispatch(addManyToCart({
                    articles,
                    nodeIdToShowNotification,
                    notificationMessage: translate('tooltip.addedmanytocart'),
                    hash: Date.now(),
                }));
            },
            addManyToFavourites: (articles) => {
                dispatch(addManyToFavourites(articles));
            },
            clearCart: (buttonDomNode) => {
                const nodeIdToShowNotification = buttonDomNode.id = Date.now();
                dispatch(clearCart({
                    nodeIdToShowNotification,
                    notificationMessage: translate('tooltip.clearcart'),
                    hash: Date.now()
                }))
            }
        }
    }

    export default connect(mapStateToProps, mapDispatchToProps)(DropZoneContainer);
